const stringToSafeSlug = (text: string) => (
  text
    .replace(/\W/g, '-')
    .replace(/\s+/g, '-')
    .replace(/^-+|-+(?=-|$)/g, '')
);

export default function getProductVanityPath(vendorVariant: {
  id: number;
  title: string;
  vendor: {
    name: string;
  };
}) {
  const slugTitle = stringToSafeSlug(vendorVariant.title);
  const slugVendor = stringToSafeSlug(vendorVariant.vendor.name);

  return `/products/details/${slugTitle}-${slugVendor}-${vendorVariant.id}`;
}
